import { Box, Stack, Typography } from '@mui/material';
import { CustomDivider } from '../Utils/CustomDivider';
import { useAppSelector, useDictionary, useIsDesktop } from 'Hooks';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { Row } from './Row';
import { LinkAllUpdates } from './LinkAllUpdates';
import { NoData } from './NoData';
import { ServerError } from '../ServerError';
import { ReferralList } from './Row/ReferralList';
import { useCallback, useEffect, useState } from 'react';
import { IUserUpdates, getUpdates } from 'API/Home/userUpdates';
import { HTTP_STATUS_CODES } from 'Enum/HttpStatusCodes';

interface IHomeUpdates {
  setShowDialog: (dialogContent: React.ReactNode) => void;
}

const LIMIT_UPDATES = 6;
const MOBILE_LIMIT_UPDATES = 4;

export const UserUpdates = ({ setShowDialog }: IHomeUpdates) => {
  const [updates, setUpdates] = useState<IUserUpdates[]>([]);
  const [serverStatus, setServerStatus] = useState<Number>();
  const [isServerError, setIsServerError] = useState(false);
  const dictionary = useDictionary(Dictionary, DICTIONARY.Home).userUpdates;
  const isDesktop = useIsDesktop();

  const imposterId = useAppSelector(
    ({ imposter: { imposterId } }) => imposterId
  );

  const init = useCallback(async () => {
    const updates = await getUpdates();

    if (
      updates &&
      (updates?.status === 200 || updates?.status === 204) &&
      updates?.data
    ) {
      setUpdates(updates.data);
    } else {
      setIsServerError(true);
    }
    setServerStatus(updates?.status);
  }, []);

  useEffect(() => {
    init();
  }, [init, imposterId]);

  return (
    <Stack sx={{ position: 'relative', mb: '48px' }}>
      <Box
        sx={
          isDesktop
            ? undefined
            : {
                position: 'absolute',
                height: 'calc(100% + 48px)',
                width: '100vw',
                top: '-24px',
                right: '-24px',
                bgcolor: 'primary.shade_200',
                zIndex: -1,
              }
        }
      />
      <Typography variant='h5' component={'h2'}>
        {dictionary.title}
      </Typography>
      <CustomDivider />
      <Stack
        sx={{
          backgroundColor: serverStatus !== 200 ? 'primary.shade_100' : '#fff',
          mt: 2,
          p: serverStatus !== 200 || !isDesktop ? '0' : '24px 16px 12px 24px',
          height: isDesktop ? '570px' : 'auto',
          borderRadius: '16px',
          justifyContent: 'center',
        }}
      >
        {serverStatus === HTTP_STATUS_CODES.OK && updates.length > 0 ? (
          <>
            <Stack
              sx={
                isDesktop
                  ? { height: '440px', overflowY: 'auto', overflowX: 'hidden' }
                  : undefined
              }
            >
              {updates
                .slice(0, isDesktop ? LIMIT_UPDATES : MOBILE_LIMIT_UPDATES)
                .map(
                  (row: IUserUpdates, index: number, array: IUserUpdates[]) => (
                    <Row
                      key={index}
                      data={row}
                      setShowDialog={() =>
                        setShowDialog(
                          <ReferralList
                            data={row.entityJSON && JSON.parse(row.entityJSON)}
                          />
                        )
                      }
                    />
                  )
                )}
            </Stack>
            <LinkAllUpdates />
          </>
        ) : (
          <NoData />
        )}
        {isServerError && <ServerError />}
      </Stack>
    </Stack>
  );
};
